<template>
    <div>
        <h5 class="mt-3">Jackpot Leaderboard</h5>
        <b-table-simple bordered striped class="mb-0">
            <thead>
                <tr>
                    <th>Place</th>
                    <th>Payout</th>
                    <th>Rewards</th>
                    <th>Contender</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    :key="leaderboardUser.user.id"
                    v-for="(leaderboardUser, index) in jackpot.leaderboardUsers"
                >
                    <td class="text-center" style="width: 1%">
                        {{ index + 1 }}
                    </td>
                    <td>
                        <div v-if="index === 0">
                            <coin-badge :amount="jackpot.payouts[index]" />
                        </div>
                        <div v-else-if="index === 1">
                            <coin-badge :amount="jackpot.payouts[index]" />
                        </div>
                        <div v-else-if="index === 2">
                            <coin-badge :amount="jackpot.payouts[index]" />
                        </div>
                        <div v-else-if="index === 3">
                            <coin-badge :amount="jackpot.payouts[index]" />
                        </div>
                        <div v-else-if="index === 4">
                            <coin-badge :amount="jackpot.payouts[index]" />
                        </div>
                    </td>
                    <td>{{ leaderboardUser.count }}</td>
                    <td>
                        <img class="mr-1" :src="leaderboardUser.user.flagUrl" />
                        <b-badge
                            v-if="onboardingUser.id === leaderboardUser.user.id"
                            variant="primary"
                            pill
                        >
                            Me
                        </b-badge>
                        <b-badge v-else variant="light" pill class="border">
                            {{ leaderboardUser.user.codename }}
                        </b-badge>
                    </td>
                </tr>
            </tbody>
        </b-table-simple>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
    },
    props: ["jackpot"],
};
</script>